import { Box, Flex } from "rebass/styled-components";
import styled from "styled-components";
import { useLocation } from "react-router-dom";
import { useUser } from "../../../Hooks/useUser";
import { Button } from "../../Button";
import { Tooltip } from "../../Tooltip";
import { DropdownNav } from "./DropdownNav";
import { NovuComponent } from "../../NovuComponent";
import { FeedbackModal } from "../../FeedbackModal";
import { CancelRetentionModal } from "MVVM/Components/Modals/CancelRetention";
import { usePortal } from "MVVM/Hooks/usePortal";
import { useManageSubscription } from "MVVM/Hooks/useManageSubscription";
import { SignatureSelectorModal } from "MVVM/Components/Signatures";
import { Avatar } from "MVVM/Components/AvatarV2";
import { TUserGroup, TUserRank } from "MVVM/@types";

const excludedNext = ["/start"];

const AuthenticatedSection = () => {
  const { allstarUser } = useUser();
  const { pathname } = useLocation();
  const onCompetitionsRoute = pathname.startsWith("/competitions");
  const {
    portalOpen: signatureSelectorOpen,
    setPortalOpen: setSignatureSelectorOpen,
    Portal: SignatureSelectorPortal,
  } = usePortal(
    <SignatureSelectorModal
      onSave={() => {
        setSignatureSelectorOpen(false);
      }}
      onCloseClick={() => {
        setSignatureSelectorOpen(false);
      }}
    />,
    "root",
  );
  const {
    isActiveSubscriber,
    handleManageSubscription,
    retentionOpen,
    handleRetentionClose,
    handleRetentionSkip,
  } = useManageSubscription();

  const loginUrl = excludedNext.includes(window.location.pathname)
    ? "/login"
    : `/login?next=${window.location.pathname}`;

  if (!allstarUser.loggedIn)
    return (
      <Flex style={{ gap: 8 }}>
        <ResponsiveWrapper>
          <Button
            size="small"
            flex={true}
            classification="tertiary"
            to={loginUrl}
          >
            Login
          </Button>
        </ResponsiveWrapper>
        <Button size="small" flex={true} to="/register">
          Sign Up
        </Button>
      </Flex>
    );

  return (
    <Flex alignItems="center" style={{ gap: "24px" }}>
      {signatureSelectorOpen && SignatureSelectorPortal}
      {!onCompetitionsRoute && (
        <ResponsiveWrapper>
          <FeedbackModal />
        </ResponsiveWrapper>
      )}
      <ResponsiveWrapper>
        <NovuComponent />
      </ResponsiveWrapper>
      <Flex alignItems="center" style={{ gap: "18px" }}>
        <Tooltip
          isVisible={false}
          type="click"
          tooltipContent={
            <DropdownNav
              openSignatureSelector={() => {
                setSignatureSelectorOpen(true);
              }}
              isActiveSubscriber={isActiveSubscriber}
              onManageSubscription={handleManageSubscription}
            />
          }
          position={{ top: "44px", left: "-300px" }}
        >
          <Avatar
            src={allstarUser?.user?.avatar}
            size="sm"
            userGroup={allstarUser.user?.userGroup.type as TUserGroup}
            rank={allstarUser.user?.rank as TUserRank}
            style={{ cursor: "pointer" }}
          />
        </Tooltip>
      </Flex>
      <CancelRetentionModal
        isOpen={retentionOpen}
        onClose={handleRetentionClose}
        onSkip={handleRetentionSkip}
      />
    </Flex>
  );
};

const ResponsiveWrapper = styled(Box)`
  @media (max-width: ${(props) => props.theme.breaks.small}) {
    display: none;
  }
`;

export { AuthenticatedSection };
